export const FORM_GROUPS = [
    {
        title: "Penjualan (nilai order, bukan uang masuk)",
        fields: [
            ["ready_stock_sales_idr", "Penjualan Ready Stock", "money", "Nilai produk yang terjual hari ini, tanpa ongkir"],
            ["new_po_sales_idr", "Penjualan PO Baru", "money", "Nilai total order PO baru hari ini (bukan DP yang diterima)"],
            ["ready_stock_order_count", "Jumlah Order Ready Stock", "count"],
            ["new_po_order_count", "Jumlah Order PO Baru", "count"],
        ],
    },
    {
        title: "Pembayaran (uang yang benar-benar diterima)",
        fields: [
            ["ready_stock_payment_idr", "Pembayaran Ready Stock Diterima", "money"],
            ["po_dp_idr", "DP PO Diterima", "money", "Uang muka PO yang masuk hari ini"],
            ["po_settlement_idr", "Pelunasan / Cicilan PO Diterima", "money", "Pembayaran sisa PO yang masuk hari ini"],
            ["marketplace_pending_idr", "Saldo Marketplace Tertunda", "money", "Dana marketplace yang belum cair — bukan uang masuk"],
            ["shipping_fee_received_idr", "Ongkir Diterima", "money", "Dicatat terpisah dari pembayaran produk"],
        ],
    },
    {
        title: "Customer",
        fields: [
            ["new_leads", "Leads Baru", "count"],
            ["closing_new_customers", "Closing Customer Baru", "count"],
            ["closing_existing_customers", "Closing Customer Lama", "count"],
        ],
    },
    {
        title: "Follow-up",
        fields: [
            ["followups_due", "Follow-up Jatuh Tempo", "count"],
            ["followups_done", "Follow-up Selesai", "count"],
            ["followups_missed", "Follow-up Terlewat", "count"],
            ["followups_pending", "Follow-up Tertunda", "count"],
        ],
    },
];

export const EMPTY_FIGURES = Object.fromEntries(FORM_GROUPS.flatMap((g) => g.fields.map(([k]) => [k, 0])));
